import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IposHelpComponent } from './ipos-help.component';
import { IposHelpCreatingUserAccountComponent } from './ipos-help-creating-user-account/ipos-help-creating-user-account.component';
import { IposHelpManageUserAccountComponent } from './ipos-help-manage-user-account/ipos-help-manage-user-account.component';
import { IposHelpNavigatingToCentralComponent } from './ipos-help-navigating-to-central/ipos-help-navigating-to-central.component';
import { IposHelpInstallationPackageComponent } from './ipos-help-installation-package/ipos-help-installation-package.component';
import { IposHelpStandardIposComponent } from './ipos-help-standard-ipos/ipos-help-standard-ipos.component';
import { CreateCustomInstallationPackageComponent } from './create-custom-installation-package/create-custom-installation-package.component';
import { IposHelpManageInstallationProfileComponent } from './ipos-help-manage-installation-profile/ipos-help-manage-installation-profile.component';
import { IposHelpFaqComponent } from './ipos-help-faq/ipos-help-faq.component';
import { IposHelpOdaComponent } from './ipos-help-oda/ipos-help-oda.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { IposHelpDeviceComponent } from './ipos-help-device/ipos-help-device.component';
import { IposHelpAssetLibraryComponent } from './ipos-help-asset-library/ipos-help-asset-library.component';
import { IposHelpAddingCustomContentToIposComponent } from './ipos-help-adding-custom-content-to-ipos/ipos-help-adding-custom-content-to-ipos.component';
import { IposHelpPartnerPortalComponent } from './ipos-help-partner-portal/ipos-help-partner-portal.component';
import { IposHelpPartnerContentComponent } from './ipos-help-partner-content/ipos-help-partner-content.component';
import { IposHelpUninstallingChromebookComponent } from './ipos-help-uninstalling-chromebook/ipos-help-uninstalling-chromebook.component';
import { IposHelpInstallingChromebookComponent } from './ipos-help-installing-chromebook/ipos-help-installing-chromebook.component';
import { IposHelpIdleAssistantComponent } from './ipos-help-idle-assistant/ipos-help-idle-assistant.component';
import { IposHelpRegionalHqComponent } from './ipos-help-regional-hq/ipos-help-regional-hq.component';
import { IposHelpUninstallationPackageComponent } from './ipos-help-uninstallation-package/ipos-help-uninstallation-package.component';
import { IposHelpSkuComponent } from './ipos-help-sku/ipos-help-sku.component';


@NgModule({
  declarations: [
    IposHelpComponent,
    IposHelpCreatingUserAccountComponent,
    IposHelpManageUserAccountComponent,
    IposHelpNavigatingToCentralComponent,
    IposHelpInstallationPackageComponent,
    IposHelpStandardIposComponent,
    CreateCustomInstallationPackageComponent,
    IposHelpManageInstallationProfileComponent,
    IposHelpDeviceComponent,
    IposHelpAssetLibraryComponent,
    IposHelpAddingCustomContentToIposComponent,
    IposHelpFaqComponent,
    IposHelpOdaComponent,
    IposHelpPartnerPortalComponent,
    IposHelpPartnerContentComponent,
    IposHelpUninstallingChromebookComponent,
    IposHelpInstallingChromebookComponent,
    IposHelpIdleAssistantComponent,
    IposHelpRegionalHqComponent,
    IposHelpUninstallationPackageComponent,
    IposHelpSkuComponent
  ],
  imports: [
    CommonModule,
    NgbModule
  ]
})
export class IposHelpModule { }
